module.exports = __webpack_public_path__ + "img/solve_pic04.9e59d5f1.jpg";